import { muiStyles } from 'utils/design';

export const useStyles = muiStyles(() => ({
  content: {
    width: '800px',
  },
}));
